import axios from 'axios';
import Config from '../../config';

export function setLanguages() {
    return async (dispatch) => {
        const language = await axios.get(Config.api.endpoint + 'api/Language',Config.getApiConfig());

        dispatch({
            type: 'SET_LANGUAGES',
            payload: {
                languages: language.data,
            }
        });

        return Promise.resolve({
            languages: language.data
        });
    }
}

export function setLanguage(language) {

    return (dispatch) => {
        dispatch({
            type: 'SET_LANGUAGE',
            payload: {
                language: language
            }
        });

        return Promise.resolve(true);
    }
}


// WEBPACK FOOTER //
// ./src/core/store/actions/language.js